import { useSelector } from 'react-redux';
import api from '@Services/api';

/**
 * Who is looking at the global Submissions tab, and what they may do.
 *
 * Admin app: `v-sub` opens the tab, `g-sub` unlocks grading; super admins
 * bypass both. Instructor app: a main instructor sees everything of their
 * own; an assistant needs the `submissions` (or `course_content`) grant. The
 * loose auth cast is deliberate — this shared source compiles under both
 * apps, and `permissions` exists only in one, `grants`/`parent_id` only in
 * the other. Backend gates remain the real enforcement.
 */
const useSubmissionsScope = () => {
	const auth = useSelector((state: any) => state.auth);
	const isAdminPortal = api.defaults.baseURL?.includes('/admin/') === true;
	const isSuper = auth?.user?.type === 'super';
	const isAssistant = !!auth?.user?.parent_id;
	const permissions: Map<string, string> | undefined = auth?.permissions;
	const grants: Map<string, string> | undefined = auth?.grants;
	const hasGrant = (code: string) => !!grants?.has?.(code);

	const canView = isAdminPortal
		? isSuper || !!permissions?.has?.('v-sub')
		: !isAssistant || hasGrant('submissions') || hasGrant('course_content');
	const canGrade = isAdminPortal
		? isSuper || !!permissions?.has?.('g-sub')
		: !isAssistant || hasGrant('submissions') || hasGrant('course_content');

	return { isAdminPortal, canView, canGrade };
};

export default useSubmissionsScope;
